// extracted by mini-css-extract-plugin
export default {"user-permission__table":"UserPermission_user-permission__table__l9F3a","table__name":"UserPermission_table__name__vPACW"};